(() => {
  'use strict';
  if (window.gdEquipmentInquiryTracking) return;

  const pendingKey = 'gd_equipment_inquiry_pending_v1';
  const measurementId = 'G-6YB77D6J5G';
  const maxAge = 30 * 60 * 1000;
  const selector = '.gd-contact-form, .gd-availability-form';
  const script = document.currentScript;
  const preview = script?.dataset.gdInquiryPreview === 'true' ||
    /^\d+$/.test(new URL(window.location.href).searchParams.get('preview_theme_id') || '');
  const ownerTest = new URL(window.location.href).searchParams.get('tracking_test') === '1';
  let completionInFlight = '';
  const campaignKey = 'gd_equipment_campaign_v1';
  const approvedCampaigns = [{ source: 'reddit', medium: 'paid_social', campaign: 'gd_mapping_fit_pilot_202610', content: 'ad_a' }];
  const guideKey = 'gd_mapping_journey_v1';
  const guideResults = ['manual_model','manual_task','module_check','existing_setup','setup_review','connectivity_review','network_compare','local_fit','ground_network','ground_local'];

  function privacyAllowed() {
    const dnt = String(navigator.doNotTrack || window.doNotTrack || '').toLowerCase();
    if (navigator.globalPrivacyControl === true || dnt === '1' || dnt === 'yes') return false;
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }

  function readGuideJourney() {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(guideKey));
      if (!value || value.guide !== 'mapping_setup' || !guideResults.includes(value.result) ||
          !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > maxAge) return null;
      return value;
    } catch { return null; }
  }

  function clearGuide() {
    try { window.sessionStorage.removeItem(guideKey); } catch {}
  }

  function restoreGuide(result) {
    const journey = readGuideJourney();
    if (!privacyAllowed() || !journey || journey.result !== result) clearGuide();
  }

  function trackGuide(action, result) {
    if (!['start','result','product_click','inquiry_click'].includes(action) ||
        (action !== 'start' && !guideResults.includes(result))) return { mode: 'invalid' };
    if (window.Shopify?.designMode || !privacyAllowed()) {
      try { window.sessionStorage.removeItem(guideKey); } catch {}
      return { mode: 'blocked' };
    }
    if (action === 'result') {
      try { window.sessionStorage.setItem(guideKey, JSON.stringify({ guide: 'mapping_setup', result, at: Date.now(), preview, test: ownerTest })); } catch {}
    }
    if (preview) return { mode: 'preview' };
    const data = {
      guide_id: 'mapping_setup', guide_action: action,
      page_location: 'https://shop.grodrones.com/pages/mapping-setup-check',
      page_title: 'Mapping setup check', page_referrer: '', send_to: measurementId
    };
    if (guideResults.includes(result)) data.guide_result = result;
    try {
      if (ownerTest) data.debug_mode = true;
      campaignEvidence(data, readCampaign());
      void sendNative(ownerTest ? 'mapping_setup_tracking_test' : 'mapping_setup_' + action, data);
      return { mode: 'pending' };
    } catch { return { mode: 'unavailable' }; }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch {}
  }

  function readPending() {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(pendingKey));
      if (!value || typeof value.id !== 'string' || !/^[a-f0-9-]{32,36}$/.test(value.id) ||
          !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > maxAge) {
        clearPending();
        return null;
      }
      return value;
    } catch { return null; }
  }

  function inquiryType(form) {
    return form.querySelector('[name="contact[Inquiry type]"]')?.value || '';
  }

  function setReturnPath(form, context) {
    const input = form.querySelector('[name="return_to"]');
    if (!input) return;
    const current = new URL(window.location.href);
    const target = new URL(current.pathname, current.origin);
    target.searchParams.set('contact_posted', 'true');
    if (context.dataset.gdInquiryContext === 'contact_page') {
      const type = inquiryType(form);
      if (type === 'Equipment sales') target.searchParams.set('inquiry', 'equipment');
      if (type === 'Order support') target.searchParams.set('inquiry', 'order');
      target.hash = form.id;
    } else {
      if (/^\d+$/.test(context.dataset.variantId || '')) target.searchParams.set('variant', context.dataset.variantId);
      target.hash = 'gd-availability';
    }
    if (/^\d+$/.test(current.searchParams.get('preview_theme_id') || '')) {
      target.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    }
    if (current.searchParams.get('tracking_test') === '1') target.searchParams.set('tracking_test', '1');
    input.value = target.pathname + target.search + target.hash;
  }

  function newId() {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto?.getRandomValues !== 'function') return '';
    return Array.from(window.crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
  }

  function prepare(form, context) {
    setReturnPath(form, context);
    clearPending();
    if (window.Shopify?.designMode || inquiryType(form) !== 'Equipment sales' || !privacyAllowed()) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    const id = newId();
    if (!id) return;
    const guide = readGuideJourney();
    const record = {
      id, at: Date.now(), form: form.id, path: window.location.pathname,
      location: context.dataset.gdInquiryContext,
      product: context.dataset.productId || '', variant: context.dataset.variantId || '',
      test: preview || guide?.preview === true || guide?.test === true || new URL(window.location.href).searchParams.get('tracking_test') === '1'
    };
    const campaign = readCampaign();
    if (campaign) record.campaign = campaign;
    if (guide) record.guide = { id: 'mapping_setup', result: guide.result };
    try { window.sessionStorage.setItem(pendingKey, JSON.stringify(record)); } catch {}
  }

  function approvedCampaign(value) {
    return value && approvedCampaigns.find(c => ['source','medium','campaign','content'].every(k => c[k] === value[k]));
  }

  function clearCampaign() {
    try { window.sessionStorage.removeItem(campaignKey); } catch {}
  }

  function captureCampaign() {
    if (!privacyAllowed() || window.Shopify?.designMode) { clearCampaign(); return; }
    const query = new URL(window.location.href).searchParams;
    if (!Array.from(query.keys()).some(k => k.startsWith('utm_'))) return;
    const fields = ['source','medium','campaign','content'];
    const value = {};
    for (const key of fields) {
      const values = query.getAll('utm_' + key);
      if (values.length !== 1) { clearCampaign(); return; }
      value[key] = values[0];
    }
    const campaign = approvedCampaign(value);
    if (!campaign) { clearCampaign(); return; }
    try { window.sessionStorage.setItem(campaignKey, JSON.stringify({ ...campaign, at: Date.now() })); } catch {}
  }

  function readCampaign() {
    if (!privacyAllowed()) return null;
    try {
      const value = JSON.parse(window.sessionStorage.getItem(campaignKey));
      if (!value || !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > maxAge) return null;
      return approvedCampaign(value) || null;
    } catch { return null; }
  }

  function campaignEvidence(data, campaign) {
    const safe = approvedCampaign(campaign);
    if (safe) for (const key of ['source','medium','campaign','content']) data['gd_campaign_' + key] = safe[key];
  }

  function nativeSession() {
    return new Promise(resolve => {
      const tag = window.gtag;
      if (typeof tag !== 'function' || !privacyAllowed()) { resolve(null); return; }
      let client = '', session = '', finished = false;
      const timer = window.setTimeout(() => finish(null), 2000);
      function finish(value) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        resolve(value);
      }
      function ready() {
        if (client && session) finish({ tag, session });
      }
      try {
        tag('get', measurementId, 'client_id', value => {
          if (typeof value === 'string' && /^[a-zA-Z0-9_.-]{1,128}$/.test(value)) client = value;
          ready();
        });
        tag('get', measurementId, 'session_id', value => {
          const safe = String(value || '');
          if (/^[1-9][0-9]{0,12}$/.test(safe)) session = safe;
          ready();
        });
      } catch { finish(null); }
    });
  }

  async function sendNative(name, data, beforeSend) {
    if (preview || window.Shopify?.designMode || !privacyAllowed()) return { mode: 'blocked' };
    const context = await nativeSession();
    if (!context || window.gtag !== context.tag) return { mode: 'unavailable' };
    if (!privacyAllowed()) return { mode: 'blocked' };
    if (beforeSend && !beforeSend()) return { mode: 'blocked' };
    try {
      context.tag('event', name, { ...data, allow_google_signals: false, allow_ad_personalization_signals: false });
      return { mode: 'queued' };
    } catch { return { mode: 'unavailable' }; }
  }

  async function complete(scope = document) {
    const pending = readPending();
    if (!pending || completionInFlight === pending.id || pending.path !== window.location.pathname) return;
    const form = document.getElementById(pending.form);
    if (!form || !scope.contains(form)) return;
    if (form.querySelector('[data-gd-inquiry-error]')) { clearPending(); return; }
    const success = form.querySelector('[data-gd-inquiry-success]');
    if (!success) return;
    if (window.Shopify?.designMode) { clearPending(); return; }
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
    if (!privacyAllowed()) { clearPending(); return; }
    const data = { lead_id: pending.id, lead_type: 'equipment',
      form_location: pending.location === 'product' ? 'shop_product_inquiry' : 'shop_contact_equipment',
      page_location: 'https://shop.grodrones.com' + pending.path,
      page_title: 'Equipment inquiry', page_referrer: '', send_to: measurementId };
    if (/^\d+$/.test(pending.product)) data.product_id = pending.product;
    if (/^\d+$/.test(pending.variant)) data.variant_id = pending.variant;
    if (pending.guide?.id === 'mapping_setup' && guideResults.includes(pending.guide.result)) {
      data.guide_id = 'mapping_setup'; data.guide_result = pending.guide.result;
    }
    if (pending.test) data.debug_mode = true;
    campaignEvidence(data, pending.campaign);
    if (preview) { clearPending(); return; }
    completionInFlight = pending.id;
    success.focus({ preventScroll: true });
    try {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('contact_posted');
      window.history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
    } catch {}
    try {
      await sendNative(pending.test ? 'lead_tracking_test' : 'generate_lead', data, () => {
        const current = readPending();
        if (!current || current.id !== pending.id) return false;
        clearPending();
        return true;
      });
    } finally { completionInFlight = ''; }
  }

  function init(scope = document) {
    captureCampaign();
    scope.querySelectorAll(selector).forEach(form => {
      const context = form.closest('[data-gd-inquiry-context]');
      if (!context || form.dataset.gdInquiryBound) return;
      form.dataset.gdInquiryBound = 'true';
      setReturnPath(form, context);
      form.addEventListener('submit', () => prepare(form, context));
    });
    complete(scope);
  }

  window.gdEquipmentInquiryTracking = { init, trackGuide, clearGuide, restoreGuide };
  init();
  window.addEventListener('load', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visitorConsentCollected', () => {
    if (!privacyAllowed()) { try { window.sessionStorage.removeItem(guideKey); } catch {} }
    if (!privacyAllowed()) { clearCampaign(); clearPending(); }
    else captureCampaign();
    complete();
  });
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) { captureCampaign(); complete(); }
    });
  }
})();
